import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import InstallPrompt from "@/components/InstallPrompt";
import { MODULES } from "@/config/modules";

import Home from "@/pages/Home";
import Relampago from "@/pages/Relampago";
import RelampagoDetail from "@/pages/RelampagoDetail";
import Petitions from "@/pages/Petitions";
import PetitionDetail from "@/pages/PetitionDetail";
import PetitionCreate from "@/pages/PetitionCreate";
import Consultations from "@/pages/Consultations";
import ConsultationDetail from "@/pages/ConsultationDetail";
import Investigations from "@/pages/Investigations";
import InvestigationDetail from "@/pages/InvestigationDetail";
import Promesometro from "@/pages/Promesometro";
import Proposals from "@/pages/Proposals";
import ProposalDetail from "@/pages/ProposalDetail";
import Reporta from "@/pages/Reporta";
import Biblioteca from "@/pages/Biblioteca";
import Entities from "@/pages/Entities";
import EntityDetail from "@/pages/EntityDetail";
import About from "@/pages/About";
import Metodologia from "@/pages/Metodologia";
import Resultados from "@/pages/Resultados";
import Login from "@/pages/Login";
import Profile from "@/pages/Profile";
import SearchPage from "@/pages/SearchPage";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollTop />
      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/relampago" element={<Layout><Relampago /></Layout>} />
        <Route path="/relampago/:id" element={<Layout><RelampagoDetail /></Layout>} />
        <Route path="/consultas" element={<Layout><Consultations /></Layout>} />
        <Route path="/encuestas" element={<Layout><Consultations /></Layout>} />
        <Route path="/consultas/:id" element={<Layout><ConsultationDetail /></Layout>} />
        <Route path="/encuestas/:id" element={<Layout><ConsultationDetail /></Layout>} />
        <Route path="/resultados" element={<Layout><Resultados /></Layout>} />
        <Route path="/propuestas" element={<Layout><Proposals /></Layout>} />
        <Route path="/propuestas/:id" element={<Layout><ProposalDetail /></Layout>} />
        <Route path="/metodologia" element={<Layout><Metodologia /></Layout>} />
        <Route path="/biblioteca" element={<Layout><Biblioteca /></Layout>} />
        <Route path="/sobre" element={<Layout><About /></Layout>} />
        <Route path="/buscar" element={<Layout><SearchPage /></Layout>} />
        <Route path="/login" element={<Layout><Login /></Layout>} />
        <Route path="/perfil" element={<ProtectedRoute><Layout><Profile /></Layout></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><Layout><AdminDashboard /></Layout></ProtectedRoute>} />

        {/* Modules hidden during the informative/collaborative transition (feature-flagged, not deleted) */}
        {MODULES.peticiones && <Route path="/peticiones" element={<Layout><Petitions /></Layout>} />}
        {MODULES.peticiones && <Route path="/peticiones/crear" element={<ProtectedRoute><Layout><PetitionCreate /></Layout></ProtectedRoute>} />}
        {MODULES.peticiones && <Route path="/peticiones/:id" element={<Layout><PetitionDetail /></Layout>} />}
        {MODULES.fiscalizacion && <Route path="/fiscalizacion" element={<Layout><Investigations /></Layout>} />}
        {MODULES.fiscalizacion && <Route path="/fiscalizacion/:id" element={<Layout><InvestigationDetail /></Layout>} />}
        {MODULES.promesometro && <Route path="/promesometro" element={<Layout><Promesometro /></Layout>} />}
        {MODULES.reporta && <Route path="/reporta" element={<Layout><Reporta /></Layout>} />}
        {MODULES.perfiles && <Route path="/perfiles" element={<Layout><Entities /></Layout>} />}
        {MODULES.perfiles && <Route path="/perfiles/:id" element={<Layout><EntityDetail /></Layout>} />}

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <InstallPrompt />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
